<template>
  <span class="avatar" :style="{
    width: width+'px',
    height: height+'px',
    padding: border +1+ 'px'
  }" :class="{'has-border': border}">
    <div class="img-container">
      <img :src="avatar" alt="avatar">
      <div class="facial-mask"></div>
    </div>
    <slot></slot>
  </span>
</template>
<script>
import defaultPng from '@/assets/img/comet/default.png'

export default {
  name: 'CtAvatar',
  props: {
    src: {
      type: String,
      required: true,
      default: ''
    },
    border: Number,
    width: Number,
    height: Number
  },
  computed: {
    avatar () {
      return this.src || defaultPng
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/_varaible.scss';
.avatar{
  display: inline-block;
  width:32px;
  height:32px;
  background:$primary;
  border-radius: 50%;
  vertical-align: middle;
  overflow: hidden;
  &.has-border{
    .img-container{
     border: 1px solid #fff;
    }
  }
  .img-container{
    display:block;
    height:100%;
    border-radius: 50%;
    overflow: hidden;
    position: relative;
  }
  img{
    width: 100%;
    height: 100%;
    vertical-align: top;
  }
  .facial-mask{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
